import { render, staticRenderFns } from "./OrderPollingOnce.vue?vue&type=template&id=1ef3391a&"
import script from "./OrderPollingOnce.vue?vue&type=script&lang=ts&"
export * from "./OrderPollingOnce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports